import { useQuery } from "react-query";

import axios, { AxiosError } from "axios";

import { SYNC_SVC_ADDRESS } from "../../../constants/app.constants";

const API_URL = `${SYNC_SVC_ADDRESS}/api/stick-sync`;

/**
 * Represents a custom field (User Defined Column) in the synced schema.
 */
export interface CustomField {
  /** Unique identifier for the custom field */
  id: string;
  name: string | null | undefined;
}

export interface FetchCustomFieldsResponse {
  customFields: CustomField[];
}

const fetchCustomFields = async (schema: string): Promise<FetchCustomFieldsResponse> => {
  const response = await axios.get<CustomField[]>(`${API_URL}/${schema}/custom-fields`);

  return { customFields: response.data };
};

export const useFetchCustomFields = (schema?: string) => {
  return useQuery<FetchCustomFieldsResponse, AxiosError>(
    ["customFields", schema],
    () => {
      if (!schema) {
        throw new Error("schema is required");
      }
      return fetchCustomFields(schema);
    },
    {
      enabled: !!schema,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000 // 10 minutes
    }
  );
};
